import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=65565d06&scoped=true&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65565d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65565d06')) {
      api.createRecord('65565d06', component.options)
    } else {
      api.reload('65565d06', component.options)
    }
    module.hot.accept("./tracking.vue?vue&type=template&id=65565d06&scoped=true&", function () {
      api.rerender('65565d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/tracking/partials/tracking.vue"
export default component.exports